export default "__VITE_ASSET__qHSOTC75__"